<template>
  <div>
    <a-drawer title="部门管理" :width="drawerWidth" @close="onClose" :visible="visible">
      <div style="height:100%;" @click.stop="popShow = false">
        
            <a-tree
              showIcon
              :treeData="treeData"
              @rightClick="onRightClick"

            ></a-tree>
            <a-divider/>
            <a-button type="primary" icon="plus-circle" @click="onSelectPopMenu(null)">增加总部门</a-button>
         
        <div
          v-if="popShow"
          class="ant-popover ant-popover-placement-right"
          style="transform-origin: 102px 50%;"
          :style="{ left: popLeft, top: popTop }"
        >
          <div class="ant-popover-content">
            <div class="ant-popover-arrow"></div>
            <div role="tooltip" class="ant-popover-inner">
              <div>
                <div class="ant-popover-inner-content">
                  <div v-for="(item,idx) in popMenus" :key="idx">
                    <a @click="onSelectPopMenu(item)">{{item['title']}}</a>
                    <div
                      v-if="idx != popMenus.length - 1"
                      class="ant-divider ant-divider-horizontal"
                      style="margin: 4px 0px;"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <a-modal
          :title="modalTitle"
          :visible="modalVisible"
          @ok="handleModalOk"
          @cancel="handleModalCancel"
          :maskClosable="false"
        >
          <a-spin size="large" :spinning="modalFormSpinning">
            <a-form :form="modalForm">
              <a-form-item label="部门角色名称">
                <a-input
                  v-decorator="[
          'departrole_name',
          {rules: [{ required: true, message: '请输入部门角色名称' }], initialValue: modalFormCurrentUpdate['departrole_name']}
        ]"
                  placeholder="请输入部门角色名称"
                />
              </a-form-item>
              <a-form-item label="部门角色属性">
                <a-select disabled
                  v-decorator="[
          'departrole_type',
          {rules: [{ required: true, message: '请选择部门角色属性' }], initialValue: modalFormCurrentUpdate['departrole_type'] ? modalFormCurrentUpdate['departrole_type'] : modalFormTypeArr.length > 0 ? modalFormTypeArr[0].value : ''}
        ]"
                  placeholder="选择部门角色属性"
                >
                  <a-select-option
                    v-for="(item,idx) in modalFormTypeArr"
                    :key="idx"
                    :value="item['value']"
                  >{{item['title']}}</a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="上级部门角色">
                <a-select
                  :disabled="true"
                  v-decorator="[
          'departrole_parentid',
          {rules: [{ required: true}],initialValue:modalFormParent['value']},
        ]"
                >
                  <a-select-option :value="modalFormParent['value']">{{modalFormParent['title']}}</a-select-option>
                </a-select>
              </a-form-item>
            </a-form>
          </a-spin>
        </a-modal>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import mixins from "../mixins";
export default {
  name: "RoleManage",
  props: ['orgId','flag'],
  mixins: [mixins],
  data() {
    return{
      visible: false,
      drawerWidth:document.body.clientWidth / 3 * 2,
      popShow: false,
      treeData: [],
      dic10005: {},

      popLeft: 0,
      popTop: 0,
      popMenus: [],

      modalTitle: "",
      modalVisible: false,
      modalForm: this.$form.createForm(this),
      modalFormTypeArr: [],
      modalFormSpinning: false,
      modalFormParent: {},
      modalFormCurrentUpdate: {},
      modalFormType: "",

      currentSelectedRole: {},
      systemArr: [
        {
          title: "驾协管理平台",
          value: "3"
        },
        {
          title: "驾校管理平台",
          value: "4"
        }
      ],
      systemArray:[],
      selectSys: "3",
      moduleTreeSpinning: false,
      moduleTreeData: [],
      moduleCheckKeys: []
    }
  },
  created() {
    this.selectSys = (this.flag == 0) ? 3 : 4;
    this.systemArray.push((this.flag == 0) ? this.systemArr[0] : this.systemArr[1])
    this.visible = true;
    const that = this;
    this.fetchDataDic(
      ["10005"],
      data => {
        that.dic10005 = data.dictlist[0]["10005"];
      },
      that
    );
    this.fetchTree();
  },
  methods: {
    onClose() {
      this.visible = false;
      this.$emit("close");
    },
    handleSysSelectChange(value, option) {
      this.selectSys = value;
      if(this.currentSelectedRole['departrole_id'] && this.selectSys) {
        this.fetchModuleByRole();
      }
    },
    fetchTree() {
      const that = this;
      this.$http.post(
        this.$marco.api.getRoleTree,
        {org_id:this.orgId,
        departrole_type:'0'
        },
        data => {
          // that.$log.success(JSON.stringify(data));
          const tree = data["departroletree"];
          this.formatHttpData(tree);

          that.treeData = tree;
        },
        errorDesc => {
          that.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.$log.error(JSON.stringify(error));
        }
      );
    },
    fetchModuleByRole() {
      const that = this;
      that.moduleTreeSpinning = true;
      this.$http.post(
        this.$marco.api.getModuleTreeForPrivilige,
        {
          departrole_id: that.currentSelectedRole['departrole_id'],
          system_id: that.selectSys
        },
        data => {
          that.moduleTreeSpinning = false;
          // that.$log.success(JSON.stringify(data));

          const moduletree = data["moduletree"];
          this.formatModuleHttpData(moduletree);
          that.moduleTreeData = moduletree;
          that.moduleCheckKeys = data['checkedmodules'];
        },
        errorDesc => {
          that.moduleTreeSpinning = false;
          that.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.moduleTreeSpinning = false;
          that.$log.error(JSON.stringify(error));
        }
      );
    },
    formatModuleHttpData(moduletree) {
      for (let i = 0; i < moduletree.length; i++) {
        moduletree[i]["key"] = moduletree[i]["module_id"];
        moduletree[i]["title"] = moduletree[i]["module_name"];
        moduletree[i]["parentId"] = moduletree[i]["parent_moduleid"];
        moduletree[i]["system_id"] = this.selectSys;
        // moduletree[i]["icon"] = <a-icon type="dot-chart" />;
        if(moduletree[i]["subMouleinfo"]) {
          moduletree[i]["children"] = moduletree[i]["subMouleinfo"];
          this.formatModuleHttpData(moduletree[i]["children"]);
        }
      }
    },
    formatHttpData(tree) {
      for (let i = 0; i < tree.length; i++) {
        tree[i]["key"] = tree[i]["departrole_id"];
        tree[i]["title"] = tree[i]["departrole_name"];
        tree[i]["parentId"] = tree[i]["departrole_parentid"];
        // tree[i]["system_id"] = this.selectSys;
        // moduletree[i]["icon"] = <a-icon type="dot-chart" />;
        if(tree[i]["departrole_type"] == '0'){
          tree[i]["icon"] = <a-icon type="home" />;
        }else if(tree[i]["departrole_type"] == '1'){
          tree[i]["icon"] = <a-icon type="user" />;
        }
        if (tree[i]["subDepartroles"]) {
          tree[i]["children"] = tree[i]["subDepartroles"];
          this.formatHttpData(tree[i]["children"]);
        }
      }
    },
    onRightClick({ event, node }) {
      const key = node.$vnode.key;
      this.modalFormCurrentUpdate = node.$vnode.data.props;
      this.genPopMenu(key);
      this.popShow = true;
      const width = node.$refs.selectHandle.offsetWidth;
      this.popLeft = event.clientX - (document.body.clientWidth - this.drawerWidth) + 40 + "px";
      //   let beside = 0;
      //   switch (n) {
      //     case 0: // 一级
      //       beside = 55;
      //       break;
      //     case 1: // 二级
      //       beside = 42;
      //       break;
      //   }
      this.popTop = event.clientY - 55 + "px";
    },
    genPopMenu(key) {
      this.popMenus = [
        {
          title: "增加子部门",
          key: key,
          type: "addSub"
        },
        {
          title: "修改部门",
          key: key,
          type: "update"
        },
        {
          title: "删除部门",
          key: key,
          type: "delete"
        }
      ];
    },
    getTreeByKey(key) {
      for (let i = 0; i < this.treeData.length; i++) {
        if (this.treeData[i]["key"] === key) {
          return this.treeData[i];
        } else {
          const children = this.treeData[i]["children"];
          if (children) {
            for (let i = 0; i < children.length; i++) {
              if (children[i]["key"] === key) {
                return children[i];
              } else {
                const children3 = children[i]["children"];
                if (children3) {
                  for (let i = 0; i < children3.length; i++) {
                    if (children3[i]["key"] === key) {
                      return children3[i];
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    onSelectPopMenu(item) {
      const key = item && item["key"] ? item["key"] : "-1";
      const that = this;
      if (item && item["type"] === "delete") {
        that.$confirm({
          title:"是否删除该部门",
          content:"删除该部门将会删除部门下的角色",
          okText: '确定',
          cancelText: '取消',
          onOk(){
            that.treeSpinning = true;
            that.$http.post(
              that.$marco.api.deleteRole,
              {
                departrole_id: key
              },
              data => {
                that.treeSpinning = false;
                that.$message.success("删除成功");
                that.fetchTree();
              },
              errorDesc => {
                that.treeSpinning = false;
                that.$message.error(errorDesc);
                that.$log.normal(JSON.stringify(errorDesc));
              },
              error => {
                that.treeSpinning = false;
                that.$log.error(JSON.stringify(error));
                that.$message.success("删除失败");
              }
            );
          },
          onCancle(){}
        })
        return;
        
      }

      that.modalVisible = true;
      const tree = this.getTreeByKey(key);
      this.modalTitle =
        tree && tree["title"] && item && item["title"]
          ? tree["title"] + "-" + item["title"]
          : "增加总部门";

      this.modalFormType = "insert";
      if (item && item["type"] === "addSub") {
        this.modalFormCurrentUpdate = {};
        this.modalFormParent["value"] = key;
        this.modalFormParent["title"] = tree["title"];
        this.modalForm.resetFields();
      } else if (item && item["type"] === "update") {
        this.modalFormType = "update";
        const parentTree = this.getTreeByKey(
          tree && tree["parentId"] ? tree["parentId"] : "-1"
        );
        this.modalFormParent["value"] = parentTree ? parentTree["key"] : "-1";
        this.modalFormParent["title"] = parentTree ? parentTree["title"] : "无";
      } else {
        this.modalFormCurrentUpdate = {};
        this.modalFormParent["value"] = "-1";
        this.modalFormParent["title"] = "无";
        this.modalForm.resetFields();
      }

      this.modalFormTypeArr = [];
      for (const key in this.dic10005) {
        if (this.dic10005.hasOwnProperty(key)) {
          const element = this.dic10005[key];
          this.modalFormTypeArr.push({
            title: element,
            value: key
          });
        }
      }
    },
    handleModalOk() {
      const that = this;
      this.modalForm.validateFields((errors, values) => {
        if (!errors) {
          that.modalFormSpinning = true;
          that.handleModalFormSubmit(values);
        }
      });
    },
    handleModalFormSubmit(values) {
      const that = this;
      if (that.modalFormType === "update") {
        values["departrole_id"] = this.modalFormCurrentUpdate["departrole_id"];
      }
      values["org_id"] = that.orgId;
      console.log(values);
      this.$http.post(
        that.modalFormType === "insert"
          ? this.$marco.api.addRole
          : this.$marco.api.updateRole,
        values,
        data => {
          that.modalFormSpinning = false;
          that.$log.success(JSON.stringify(data));
          that.$message.success(
            that.modalFormType === "insert" ? "添加成功" : "修改成功"
          );
          that.modalVisible = false;

          that.fetchTree();
        },
        errorDesc => {
          that.modalFormSpinning = false;
          that.$message.error(errorDesc);
        },
        error => {
          that.modalFormSpinning = false;
          that.$log.error(error);
          that.$message.error(
            that.modalFormType === "insert" ? "添加失败" : "修改失败"
          );
        },
        that
      );
    },
    handleModalCancel() {
      this.modalVisible = false;
    },
    onRoleTreeSelect (selectedKeys, info) {
      this.currentSelectedRole['departrole_id'] = selectedKeys[0];
      if(this.currentSelectedRole['departrole_id'] && this.selectSys) {
        this.fetchModuleByRole();
      }
    },
    onModuleCheck (checkedKeys) {
      this.moduleCheckKeys = checkedKeys;
    },
    signPrivilige(){
      const that = this;
      that.moduleTreeSpinning = true;
      this.$http.post(
        this.$marco.api.signPrivilige,
        {
          checkedmodules: that.moduleCheckKeys,
          departrole_id: that.currentSelectedRole['departrole_id']
        },
        data => {
          that.moduleTreeSpinning = false;
          that.$log.success(JSON.stringify(data));
          that.fetchModuleByRole();
        },
        errorDesc => {
          that.moduleTreeSpinning = false;
          that.$log.normal(JSON.stringify(errorDesc));
        },
        error => {
          that.moduleTreeSpinning = false;
          that.$log.error(JSON.stringify(error));
        }
      );
    }
  }
};
</script>
<style scope="scoped">
.ant-form-item {
  margin-bottom: 0;
}
</style>
